// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // url: 'http://139.99.8.115:3051/api',
  // socket_url: '/',
  url: 'https://ns30-api.lexiglobal.my/api',
  socket_url: 'https://ns30-api.lexiglobal.my',
  firebaseConfig: {
    apiKey: "AIzaSyAZU3DVCLXQU3xhKjPWmsy3eYNHNO2A9pY",
    authDomain: "test-8ec4c.firebaseapp.com",
    projectId: "test-8ec4c",
    storageBucket: "test-8ec4c.firebasestorage.app",
    messagingSenderId: "172133645978",
    appId: "1:172133645978:web:2d3ad585fbbc6e499ea923",
    measurementId: "G-X6LW43377Z"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
